import Vue from 'vue'
import { formatRelative, format } from 'date-fns'
import { enUS } from 'date-fns/esm/locale'
import numeral from 'numeral'

import store from '../store'

Vue.filter('toNumber', (value, format = '0,0.00') => {
	return numeral(value).format(format)
})

Vue.filter('toCurrency', (value, currency = 'GHS', format = 'en') => {
	const number = parseFloat(value)

	if (typeof number !== 'number') {
		return value
	}

	const formatter = new Intl.NumberFormat(format, {
		style: 'currency',
		currency: currency,
		minimumFractionDigits: 2,
	})

	const money = formatter.format(number)
	const currency_locale = store.getters.currencies(true)

	return money.replace(currency_locale[currency].symbol, `${currency_locale[currency].iso} `)
})

Vue.filter('toPercentage', value => {
	return value ? `${(value * 100).toFixed(2)}%` : null
})

Vue.filter('toDate', (value, pattern = 'MM/dd/yyyy') => {
	if (value) {
		return format(new Date(value), pattern)
	}
	return null
})

Vue.filter('toAnswer', value => {
	return value ? 'Yes' : 'No'
})

Vue.filter('toStartCase', value => {
	return _.startCase(value)
})

Vue.filter('capitalize', value => {
	return _.capitalize(value)
})

Vue.filter('toLowerCase', value => {
	return _.lowerCase(value)
})

Vue.filter('truncate', (value, length = 15, suffix = '...') => {
	return value.length > length ? value.substring(0, length) + suffix : value
})

Vue.filter('placeholder', (value, placeholder = 'N/A') => {
	return !_.isEmpty(value) ? value : placeholder
})

Vue.filter('toGender', value => {
	if (value) {
		return value === 'M' ? 'Male' : 'Female'
	}
	return null
})

Vue.filter('replace', (value, replace, _with) => {
	return _.replace(value, replace, _with)
})

Vue.filter('floor', (value, precision) => {
	return _.floor(value, precision)
})

Vue.filter('formatRelativeDate', (date, baseDate = new Date(), formatLocale = null) => {
	const formatRelativeLocale = formatLocale ?? {
		today: "'Today', MMM do'",
		yesterday: "'Yesterday', MMM do",
		lastWeek: "'Last' iiii, MMM do",
		other: 'MMMM do yyyy',
	}

	const locale = {
		...enUS,
		formatRelative: token => formatRelativeLocale[token],
	}

	return formatRelative(new Date(date), baseDate, { locale })
})
